import { c as _c } from "react/compiler-runtime";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { layoutHeaderClasses, layoutHeaderBigClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
import { darkTextureWrapper, colorSettingDetection, renderHeaderConditionally } from "../../utils/functions";
export interface SearchQuickLink {
  id?: string;
  title: string;
  searchString: string;
}
export interface LayoutSearchProps {
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  subheader?: string;
  description?: string;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  buttons?: TerraLink[];
  searchPlaceholderText?: string;
  quickLinks?: SearchQuickLink[];
  onQuickLinkClick?: (searchString: string) => void;
  searchContent?: React.ReactNode;
}
export const LayoutSearch = t0 => {
  const $ = _c(34);
  const {
    eyebrow,
    header,
    headerElement: t1,
    subheader,
    description,
    presetTheme,
    isHeaderBig,
    isWrapped,
    buttons,
    quickLinks,
    onQuickLinkClick,
    searchContent
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const wrapperClasses = isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px] t2-container" : "";
  const t2 = presetTheme || "";
  let t3;
  if ($[0] !== t2) {
    t3 = colorSettingDetection(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const colorSetting = t3;
  const mainClasses = `py-[100px] ${presetTheme || ""} ${colorSetting}`;
  const headerClasses = `${isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses}`;
  const t4 = header || "";
  let t5;
  if ($[2] !== headerClasses || $[3] !== headerElement || $[4] !== t4) {
    t5 = renderHeaderConditionally(headerClasses, t4, headerElement);
    $[2] = headerClasses;
    $[3] = headerElement;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const finalHeader = t5;
  const t6 = presetTheme || "";
  let t7;
  if ($[6] !== t6) {
    t7 = darkTextureWrapper(t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const componentStyles = t7;
  let t8;
  if ($[8] !== eyebrow) {
    t8 = eyebrow && <div className={layoutEyebrowClasses}>{eyebrow}</div>;
    $[8] = eyebrow;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== subheader) {
    t9 = subheader && <div className={layoutSubheaderClasses}>{subheader}</div>;
    $[10] = subheader;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== description) {
    t10 = description && <CommonDescription description={description} className="t2-layout__description mb-8" />;
    $[12] = description;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== searchContent) {
    t11 = <div className="mt-8" data-testid="layout-search-input-area">{searchContent}</div>;
    $[14] = searchContent;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onQuickLinkClick || $[17] !== quickLinks) {
    t12 = quickLinks && quickLinks.length > 0 && <div className="nav-search__search-links" data-testid="layout-search-quick-links"><div className="nav-search__search-links--header">Related searches</div><ul className="nav-search__search-links__list">{quickLinks.map((link, index) => <li key={link.id || index}><button type="button" onClick={() => onQuickLinkClick?.(link.searchString)} className="nav-search__search-links--search-link">{link.title}</button></li>)}</ul></div>;
    $[16] = onQuickLinkClick;
    $[17] = quickLinks;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== buttons) {
    t13 = buttons && buttons.length > 0 && <div className="t2-layout__cta mt-10 text-center">{buttons.map(_temp)}</div>;
    $[19] = buttons;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== finalHeader || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t8 || $[27] !== t9 || $[28] !== wrapperClasses) {
    t14 = <div className={wrapperClasses}>{t8}{finalHeader}{t9}{t10}{t11}{t12}{t13}</div>;
    $[21] = finalHeader;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t8;
    $[27] = t9;
    $[28] = wrapperClasses;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== componentStyles || $[31] !== mainClasses || $[32] !== t14) {
    t15 = <div className={mainClasses} style={componentStyles} data-testid="layout-search">{t14}</div>;
    $[30] = componentStyles;
    $[31] = mainClasses;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
function _temp(btn, index_0) {
  return <TerraLink key={index_0} {...btn} primary={index_0 === 0} />;
}